interface PriceTier {
  tierMin?: number | string | null;
  price: number | { priceAmount: number } | string;
}

interface AddOnWithTiers {
  id?: string;
  priceTiers?: PriceTier[];
}

const getTierMin = (tier: PriceTier): number => {
  if (tier.tierMin == null || tier.tierMin === '') {
    return 0;
  }

  const tierMin = Number(tier.tierMin);

  return Number.isFinite(tierMin) ? tierMin : Number.POSITIVE_INFINITY;
};

const getTierPrice = (tier: PriceTier): number => {
  const { price } = tier;

  if (typeof price === 'number') {
    return price;
  }

  if (price && typeof (price as { priceAmount: number }).priceAmount === 'number') {
    return (price as { priceAmount: number }).priceAmount;
  }

  const numericPrice = Number(price);

  return Number.isFinite(numericPrice) ? numericPrice : 0;
};

const sortTiersByTierMin = (tiers: PriceTier[]): PriceTier[] =>
  [...tiers].sort((leftTier, rightTier) => getTierMin(leftTier) - getTierMin(rightTier));

export const getStartingPriceFromAddOn = (addOn: AddOnWithTiers): number => {
  const sortedTiers = sortTiersByTierMin(addOn.priceTiers ?? []);

  if (!sortedTiers.length) {
    return 0;
  }

  const lowestTierMin = getTierMin(sortedTiers[0]);
  const tiersAtLowestTierMin = sortedTiers.filter((tier) => getTierMin(tier) === lowestTierMin);

  const firstPaidTierAtLowestTierMin = tiersAtLowestTierMin.find((tier) => getTierPrice(tier) > 0);

  if (firstPaidTierAtLowestTierMin) {
    return getTierPrice(firstPaidTierAtLowestTierMin);
  }

  // Lowest volume tier is free (e.g. premium-included). Do not fall through to higher tiers.
  return getTierPrice(tiersAtLowestTierMin[0]);
};
